import { FC } from "react";
import { Alert, Button, Modal, Space, Tooltip } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import useDateWatch from "hooks/useDateWatch";
import { useMatch } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";

import { RecurringSettingsFieldProps } from "./types";
import RecurringSettingsForm from "./partials/RecurringSettingsForm";
import {
  useOnEventDateUpdate,
  useRecurringSettingsField,
  useRecurringSettingsFieldErrors,
  useRecurringSettingsString,
} from "./hooks";
import { RECURRING_SETTINGS_FORM_INITIAL_VALUES } from "./consts";

const RecurringSettingsField: FC<RecurringSettingsFieldProps> = (props) => {
  const intl = useIntl();
  const isDetailsRoute = !!useMatch(ROUTE_PATHS.RecuringEventDetails);
  const { value } = props;
  const eventDate = useDateWatch(["input", "date"]);
  const {
    closeModal,
    openModal,
    onRecurringSettingsFormSubmit,
    showRecurringSettingsModal,
  } = useRecurringSettingsField(props);
  const recurringSettingsString = useRecurringSettingsString(value, eventDate);
  const fields = useRecurringSettingsFieldErrors([
    "input",
    "recurringSettings",
  ]);
  const openModalButton = (
    <Button type="primary" disabled={!eventDate} onClick={openModal} block>
      {isDetailsRoute ? (
        <FormattedMessage defaultMessage="View" />
      ) : (
        <FormattedMessage defaultMessage="Edit" />
      )}
    </Button>
  );

  useOnEventDateUpdate(props, eventDate);

  return (
    <>
      <Space direction="vertical" style={{ display: "flex" }}>
        {eventDate ? (
          openModalButton
        ) : (
          <Tooltip
            title={intl.formatMessage({
              defaultMessage: "You have to select event template date first",
            })}
          >
            {openModalButton}
          </Tooltip>
        )}
        {recurringSettingsString && (
          <Alert type="info" message={recurringSettingsString} />
        )}
      </Space>
      <Modal
        title={<FormattedMessage defaultMessage="Recurring settings" />}
        open={showRecurringSettingsModal}
        footer={null}
        width={900}
        onCancel={closeModal}
        destroyOnClose
      >
        {eventDate && (
          <RecurringSettingsForm
            initialValues={value || RECURRING_SETTINGS_FORM_INITIAL_VALUES}
            onFinish={onRecurringSettingsFormSubmit}
            onClose={closeModal}
            {...{ fields, eventDate }}
          />
        )}
      </Modal>
    </>
  );
};

export default RecurringSettingsField;
